import { MainLogoImage, MaintenanceIcon } from 'assets'
import React from 'react'
import './maintenance.css'

function MaintenancePage() {
    return (
        <>
            <div className='nav-bar-header fixed-top navbar navbar-expand-xl navbar-light'>
                <div className='logo-section'>
                    <img
                        alt='logo'
                        src={MainLogoImage}
                        className='header-logo'
                    />
                </div>
            </div>
            <div class='container'>
                <div class='maintenance-box'>
                    <MaintenanceIcon className='maintenance-image'/>
                    <h1 className='text-uppercase font-weight-bold'>
                        {' '}
                        We'll be back soon!
                    </h1>
                    <p>
                        Our application is temporarily offline for scheduled
                        maintenance.
                        <br />
                        We're working hard to bring everything back online as
                        quickly as possible.
                    </p>
                    <div class='loader'></div>
                </div>
            </div>
        </>
    )
}

export default MaintenancePage
